__turbopack_context__.v({
  "body": "apple-prompt-module-scss-module__9DWlbG__body",
  "cancel-btn": "apple-prompt-module-scss-module__9DWlbG__cancel-btn",
  "description": "apple-prompt-module-scss-module__9DWlbG__description",
  "header": "apple-prompt-module-scss-module__9DWlbG__header",
  "home-icon": "apple-prompt-module-scss-module__9DWlbG__home-icon",
  "instruction-step": "apple-prompt-module-scss-module__9DWlbG__instruction-step",
  "instructions": "apple-prompt-module-scss-module__9DWlbG__instructions",
  "is-hidden": "apple-prompt-module-scss-module__9DWlbG__is-hidden",
  "is-modern": "apple-prompt-module-scss-module__9DWlbG__is-modern",
  "is-safari": "apple-prompt-module-scss-module__9DWlbG__is-safari",
  "is-visible": "apple-prompt-module-scss-module__9DWlbG__is-visible",
  "overlay": "apple-prompt-module-scss-module__9DWlbG__overlay",
  "paragraph": "apple-prompt-module-scss-module__9DWlbG__paragraph",
  "paragraph--bold": "apple-prompt-module-scss-module__9DWlbG__paragraph--bold",
  "prompt": "apple-prompt-module-scss-module__9DWlbG__prompt",
  "share-icon": "apple-prompt-module-scss-module__9DWlbG__share-icon",
  "title": "apple-prompt-module-scss-module__9DWlbG__title",
});
